import { useEffect, useState } from "react";
import {
  Box,
  List,
  Badge,
  Avatar,
  Divider,
  Typography,
  IconButton,
  ListItemText,
  ListItemAvatar,
  ListItemButton,
  ListItem,
} from "@mui/material";
import Scrollbar from "../../components/Scrollbar";
import MenuPopover from "../../components/MenuPopover";
import {
  AccessTime,
  Circle,
  NotificationAddRounded,
} from "@mui/icons-material";
import { TWO_COLOR_SHADES } from "../../theme/shades";
import { createMessage, getIcon } from "../../manager/cardManager";
import {
  getNotifications,
  markNotificationAsRead,
} from "../../services/dataService";
import { useNavigate } from "react-router-dom";
import { impexDateFormat } from "../../manager/dateManager";

export default function NotificationsPopover() {
  const pettle = TWO_COLOR_SHADES["skyblue"];
  const [notifications, setNotifications] = useState([]);

  const [open, setOpen] = useState(false);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const requestNotifications = async () => {
    try {
      const response = await getNotifications();
      setNotifications(response.data);
    } catch (error) {
      setNotifications([]);
    }
  };

  const readNotification = async (notification) => {
    if (notification.isRead !== 1) {
      try {
        await markNotificationAsRead(notification.ID);
        const updatedNotifications = [];
        let read = {};
        notifications.forEach((item) => {
          if (item.ID === notification.ID) {
            return (read = {
              ...item,
              isRead: 1,
            });
          }
          updatedNotifications.push(item);
        });
        setNotifications([...updatedNotifications, read]);
      } catch (error) {}
    }
  };

  const handleClose = () => {
    setOpen(!open);
  };

  useEffect(() => {
    requestNotifications();
  }, []);

  const unreadNotifications = notifications.filter(
    (item) => item.isRead === 0
  ).length;

  return (
    <>
      <IconButton
        color="info"
        sx={{
          mr: 1,
          backgroundColor: pettle.light,
          height: "30px",
          width: "30px",
        }}
        onClick={handleOpen}
      >
        <Badge
          badgeContent={unreadNotifications}
          sx={{
            "& .MuiBadge-badge": { fontSize: 9, height: 15, minWidth: 15 },
          }}
          color="error"
        >
          <NotificationAddRounded fontSize="small" />
        </Badge>
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{ width: 330, p: 0, mt: 1, ml: 0.75 }}
      >
        <Box sx={{ display: "flex", alignItems: "center", py: 1.5, px: 2 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" sx={{ fontSize: "12px" }}>
              Notifications
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", fontSize: "11px" }}
            >
              You have {unreadNotifications} unread notifications
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <Scrollbar sx={{ height: { xs: 300, sm: "auto", lg: "400px" } }}>
          <List disablePadding>
            {notifications.map((notification, index) => (
              <NotificationItem
                key={index}
                notification={notification}
                readNotification={readNotification}
              />
            ))}
          </List>
        </Scrollbar>

        <Box sx={{ p: 1 }}>
          <Divider sx={{ borderStyle: "dashed" }} />
        </Box>
      </MenuPopover>
    </>
  );
}

function NotificationItem({ notification, readNotification }) {
  const navigate = useNavigate();
  return (
    <ListItem
      sx={{
        p: 0,
        mt: "1px",
        alignItems: "flex-start",
      }}
      secondaryAction={
        notification.isRead === 0 && (
          <Circle
            fontSize="1px !important"
            color="#0050ff"
            sx={{
              height: "6px",
              width: "6px",
              color: "#0050ff",
              boxShadow: "0px 0px 20px #0050ff",
            }}
          />
        )
      }
      onClick={() => {
        readNotification(notification);
        if (notification.ModuleName === "Purchase Order") {
          navigate(`/impex/purchase-orders/${notification.RedirectId}`);
        } else if (notification.ModuleName === "Invoice Screen") {
          navigate(
            `/impex/invoices/${notification.RedirectId}?inv=${notification.InvoiceNo}`
          );
        }
      }}
    >
      <ListItemButton>
        <ListItemAvatar>
          <Avatar
            sx={{
              bgcolor: "background.neutral",
              height: "24px",
              width: "24px",
            }}
          >
            {getIcon(notification, "notification")}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: "12px",
                whiteSpace: "initial",
                wordWrap: "break-word",
              }}
            >
              {notification.Header}
              <Typography
                component="span"
                variant="body2"
                sx={{ color: "text.secondary", ml: 0.2, fontSize: "12px" }}
              >
                {createMessage(notification)}
              </Typography>
            </Typography>
          }
          secondary={
            <Typography
              variant="caption"
              sx={{
                mt: 0.5,
                display: "flex",
                alignItems: "center",
                color: "text.disabled",
                fontSize: "10px",
              }}
            >
              <AccessTime
                fontSize="10px"
                sx={{
                  marginRight: 1,
                }}
              />
              {impexDateFormat(notification.CreatedDate)}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  );
}
